/**
 * Per-device preference for whether to show the post-submit "what happens
 * next" interstitial after creating a new RFQ.
 *
 * Stored in localStorage under a namespaced key so the user can opt out
 * once and have that stick across sessions on the same device. Wrapped in
 * try/catch because localStorage can throw in iOS private mode and inside
 * some embedded webviews.
 */

const STORAGE_KEY = "qchbpp.rfq.skipNextSteps";

export function getSkipNextSteps(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setSkipNextSteps(value: boolean): void {
  try {
    if (value) {
      window.localStorage.setItem(STORAGE_KEY, "1");
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Best-effort. If storage is unavailable the preference simply
    // doesn't persist; the screen will keep showing on future submits.
  }
}
